import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ServiceProviderService } from '../../Service/Service-providers/service-provider.service';
import { ToastService } from '../../Service/ToastService/toast.service';
import { Router } from '@angular/router';
import { FormStateService } from '../../module/service-provider/add-sp-new-component/form-state.service';

@Component({
  selector: 'app-newpassword',
  templateUrl: './newpassword.component.html',
  styleUrl: './newpassword.component.scss'
})
export class NewpasswordComponent {

  @Input() visible: boolean = false;
  @Output() onClose = new EventEmitter<void>();

model = {
  newPassword: '',
  confirmPassword: '',
  phoneNumber: '', 
};

constructor(
    private spService: ServiceProviderService,
    private toastService: ToastService,
    private router: Router,
    private formstate: FormStateService
  ) { }
onSubmit() {
  if (this.model.newPassword && this.model.newPassword === this.model.confirmPassword) {
    const resetPasswordToken = localStorage.getItem('resetPasswordToken');
    const phoneNumber = localStorage.getItem('verifiedPhoneNumber');

    if (resetPasswordToken && phoneNumber) {
      const payload = {
        phoneNumber: phoneNumber,
        resetPasswordToken: resetPasswordToken,
        newPassword: this.model.newPassword
      };

      this.spService.resetPassword(payload).subscribe({
        next: (res: any) => {
          if (res?.isSuccess) {
            localStorage.removeItem('resetPasswordToken');
            localStorage.removeItem('verifiedPhoneNumber');
            this.router.navigate(['/login']);
          } else {
            console.error('Password reset failed:', res.errors);
          }
        },
        error: (err) => {
          console.error('API Error:', err);
        }
      });
    } else {
      console.error('Missing reset token or phone number in localStorage');
    }
  } else {
    console.error('Passwords do not match');
  }
}

}
